import React from "react";
import ListeServices from "src/pages/listeservices/ListeServices";
import ValidationCGU from "src/pages/validationCGU/ValidationCGU";
import { useAppState } from "src/app/state/StateProvider";
import AppCol from "src/commun/composants/grille/AppCol";
import AppInformation from "src/commun/composants/AppInformation/AppInformation";
import AppRow from "src/commun/composants/grille/AppRow";

const Accueil = () => {
  const [{ user, employeurs}] = useAppState();

  if (user && user.typePersonne === "Externe" && !user.cguAccepted) {
    // Si l'utilisateur est connecté et n'a pas accepté la derniere version des CGU
    return <ValidationCGU/>;
  }

  if ((user && user?.typePersonne === "Externe" && !user?.comptePersonnel && (employeurs && employeurs.length === 0))) {
    return (
      <AppRow className={"justify-content-md-center"} style={{paddingTop:"100px"}}>
        <AppCol md={{ span: 8 }}>
          <AppInformation texte="warning.affilie.desactive"/>
        </AppCol>
      </AppRow>
    )
  }

  return (
    <ListeServices/>
  );
};

export default Accueil;